import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import ProductTagsQuery from 'Query/ProductTags.query';
import { fetchQuery } from 'Util/Request';

import ProductTags from './ProductTags.component';

/** @namespace Pwa/Component/ProductTags/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isMobile: state.ConfigReducer.device.isMobile,
});

/** @namespace Pwa/Component/ProductTags/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Pwa/Component/ProductTags/Container */
export class ProductTagsContainer extends PureComponent {
    static propTypes = {
        productId: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    };

    state = {
        productTags: [],
    };

    componentDidMount() {
        this.requestProductTags();
    }

    requestProductTags() {
        const { productId } = this.props;
        fetchQuery(ProductTagsQuery.getProductTagsQuery(productId))
            .then(
                /** @namespace Pwa/Component/ProductTags/Container/ProductTagsContainer/requestProductTags/then/catch/fetchQuery/then */
                (data) => {
                    this.setState({ productTags: data.productTagsByProductId.items });
                }
            )
            .catch(
                /** @namespace Pwa/Component/ProductTags/Container/ProductTagsContainer/requestProductTags/then/catch */
                () => []
            );
    }

    containerProps() {
        const { productId, name, isMobile } = this.props;
        const { productTags } = this.state;

        return {
            name,
            productId,
            productTags,
            isMobile,
        };
    }

    render() {
        return <ProductTags {...this.containerProps()} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductTagsContainer);
